import { VStack, Divider, Text, Icon, Button, HStack, Flex, Spacer } from '@chakra-ui/react';

import { IoChatbubbleEllipsesOutline, IoStopwatchOutline } from 'react-icons/io5';

type GroupingNoticeProps = {
  isHost: boolean;
  hostName: string;
  note: string;
  onCancel?: () => void;
};

export default function GroupingNotice({ isHost, hostName, note, onCancel }: GroupingNoticeProps) {
  return (
    <VStack align="stretch" borderWidth="1px" borderColor="primary" p={2} borderRadius="5px">
      <Text fontSize="sm" fontWeight="bold">
        {isHost ? '正在揪團中' : `您正在${hostName}的揪團訂`}
      </Text>

      {note && (
        <HStack>
          <Icon as={IoChatbubbleEllipsesOutline} boxSize="1.25rem" />
          <Text fontSize="xs">{note}</Text>
        </HStack>
      )}

      <Divider />

      <Flex>
        <HStack>
          <Icon as={IoStopwatchOutline} boxSize="1.5rem" />
          <Text fontSize="sm">儘快點餐</Text>
        </HStack>
        <Spacer />
        <Button variant="unstyled" size="xs" color="gray.400" onClick={onCancel}>
          取消揪團
        </Button>
      </Flex>
    </VStack>
  );
}
